import { UrlParamKeys } from '../../app/UrlParamKeys';
import { Tableau } from '../../common/utilities/TableauLog';
import { Helpers } from '../helpers/Helpers';
import { Module } from '../Module';
import { IAddOAuthResponseListenerWindow } from './AddOAuthCredentialAction';

export interface PopupStateParams extends ng.ui.IStateParamsService {
  closePopupWhenDone: string;
}

interface IOpenerPage extends IAddOAuthResponseListenerWindow {
  tab: {
    LogOnView: {
      fireLogOnComplete: () => void;
    }
  };
}

export class WindowPopupService {

  public static $inject = [
    '$location',
    '$window'
  ];

  constructor(
    private $location: ng.ILocationService,
    private $window: ng.IWindowService) { }

  private safelyCallFunction(func: () => void) {
    try {
      func();
    } catch (e) {
      Tableau.Logger().error(e);
    }
  }

  public maybeNotifyAndClose(): boolean {
    const closePopupWhenDone = Helpers.BooleanQueryParamRegex.test(this.$location.search()[UrlParamKeys.ClosePopupWhenDone]);
    const openerPage = <IOpenerPage> (<any>this.$window.opener);
    if (openerPage && closePopupWhenDone) {
      if (openerPage.tableauPopupComplete) {
        this.safelyCallFunction(() => openerPage.tableauPopupComplete());
      }
      if (openerPage.tab && openerPage.tab.LogOnView) {
        this.safelyCallFunction(() => openerPage.tab.LogOnView.fireLogOnComplete());
      }

      this.$window.close();
      return true;
    }
  }

}

Module.instance().service('WindowPopupService', WindowPopupService);
